import { render, staticRenderFns } from "./user-detail.vue?vue&type=template&id=d8d305a2&"
import script from "./user-detail.vue?vue&type=script&lang=ts&"
export * from "./user-detail.vue?vue&type=script&lang=ts&"
import style0 from "./user-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports